'use es6';

import { createContext } from 'react';
export var defaultModalTransitionContext = {
  transitioning: false
};
export var ModalTransitionContext = createContext(defaultModalTransitionContext);
var ModalTransitionContextConsumer = ModalTransitionContext.Consumer,
    ModalTransitionContextProvider = ModalTransitionContext.Provider;
export { ModalTransitionContextConsumer, ModalTransitionContextProvider };